export default [
  {
    path: '/app/projects',
    name: 'Projects',
    component: () => import('@/views/Projects/Index.vue'),
    meta: {
      pageTitle: 'Projeler',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'PROJECTS_LIST',
      action: 'read',
      packageLimit: {
        subject: 'PROJECTS',
        limit: 1,
      },
    },
  },
  {
    path: '/app/projects/add',
    name: 'ProjectAdd',
    component: () => import('@/views/Projects/Add.vue'),
    meta: {
      navActiveLink: 'Projects',
      pageTitle: 'Projeler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/projects',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'PROJECTS_ADD',
      action: 'read',
      packageLimit: {
        subject: 'PROJECTS_MANAGE',
        limit: 1,
      },
    },
  },
  {
    path: '/app/projects/edit/:id',
    name: 'ProjectEdit',
    component: () => import('@/views/Projects/Edit.vue'),
    meta: {
      navActiveLink: 'Projects',
      pageTitle: 'Projeler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/projects',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'PROJECTS_EDIT',
      action: 'read',
      packageLimit: {
        subject: 'PROJECTS_MANAGE',
        limit: 1,
      },
    },
  },
  {
    path: '/app/projects/view/:id',
    name: 'ProjectView',
    component: () => import('@/views/Projects/View.vue'),
    meta: {
      navActiveLink: 'Projects',
      pageTitle: 'Projeler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/projects',
          active: false,
        },
        {
          text: 'Görüntüle',
          active: true,
        },
      ],
      resource: 'PROJECTS_VIEW',
      action: 'read',
      packageLimit: {
        subject: 'PROJECTS_MANAGE',
        limit: 1,
      },
    },
  },
  {
    path: '/app/projects/edit/:id/files/add',
    name: 'ProjectFilesAdd',
    component: () => import('@/views/Projects/elements/ProjectFiles/Add.vue'),
    meta: {
      navActiveLink: 'Projects',
      pageTitle: 'Proje Dokümanları',
      breadcrumb: [
        {
          text: 'Projeler',
          to: '/app/projects',
          active: false,
        },
        {
          text: 'Dosya Ekle',
          active: true,
        },
      ],
      resource: 'PROJECT_FILES_ADD',
      action: 'read',
      packageLimit: {
        subject: 'PROJECTS_MANAGE',
        limit: 1,
      },
    },
  },
  {
    path: '/app/projects/edit/:id/files/add-secret',
    name: 'ProjectFilesAdd',
    component: () => import('@/views/Projects/elements/ProjectFiles/AddSecret.vue'),
    meta: {
      navActiveLink: 'Projects',
      pageTitle: 'Proje Dokümanları',
      breadcrumb: [
        {
          text: 'Projeler',
          to: '/app/projects',
          active: false,
        },
        {
          text: 'Dosya Ekle',
          active: true,
        },
      ],
      resource: 'PROJECT_FILES_ADD_SECRET',
      action: 'read',
      packageLimit: {
        subject: 'PROJECTS_SECRET_FILES',
        limit: 1,
      },
    },
  },
  {
    path: '/app/projects/edit/:id/files/edit/:id_project_files',
    name: 'ProjectFilesEdit',
    component: () => import('@/views/Projects/elements/ProjectFiles/Edit.vue'),
    meta: {
      navActiveLink: 'Projects',
      pageTitle: 'Proje Dokümanları',
      breadcrumb: [
        {
          text: 'Projeler',
          to: '/app/projects',
          active: false,
        },
        {
          text: 'Dosya Güncelle',
          active: true,
        },
      ],
      resource: 'PROJECT_FILES_EDIT',
      action: 'read',
      packageLimit: {
        subject: 'PROJECTS_MANAGE',
        limit: 1,
      },
    },
  },
]
